import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://salon.rockyroadsolutions.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  register: (userData: any) =>
    api.post('/auth/register', userData),
  refreshToken: (token: string) =>
    api.post('/auth/refresh', { token }),
};

// Users API
export const usersAPI = {
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data: any) => api.put('/users/profile', data),
  getStaff: (locationId?: number) => 
    api.get('/users/staff', { params: { locationId } }),
  updateStaffAvailability: (staffId: number, availability: any) =>
    api.put(`/users/staff/${staffId}/availability`, { availability }),
};

// Appointments API
export const appointmentsAPI = {
  getAppointments: (params: any) => api.get('/appointments', { params }),
  createAppointment: (data: any) => api.post('/appointments', data),
  updateAppointment: (id: number, data: any) => api.put(`/appointments/${id}`, data),
  cancelAppointment: (id: number) => api.delete(`/appointments/${id}`),
  getAvailableSlots: (params: any) => api.get('/appointments/available-slots', { params }),
};

// Services API
export const servicesAPI = {
  getServices: (locationId?: number) => 
    api.get('/services', { params: { locationId } }),
  createService: (data: any) => api.post('/services', data),
  updateService: (id: number, data: any) => api.put(`/services/${id}`, data),
  deleteService: (id: number) => api.delete(`/services/${id}`),
};

// Locations API
export const locationsAPI = {
  getLocations: () => api.get('/locations'),
  createLocation: (data: any) => api.post('/locations', data),
};

// Notifications API
export const notificationsAPI = {
  getNotifications: (params: any) => api.get('/notifications', { params }),
};

// Payments API
export const paymentsAPI = {
  createPaymentIntent: (data: any) => api.post('/payments/create-intent', data),
  getPayments: () => api.get('/payments'),
};

// Dashboard API
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getTrends: (period: number) => api.get('/dashboard/trends', { params: { period } }),
};

export default api;
